export const onSecretExpiry = async (secretName) => {
  if (!window?.asos?.sdk?.identity) {
    const identityError = new Error("ASOS Identity SDK is not available.");
    window?.newrelic?.noticeError(identityError, {});

    throw new Error(identityError);
  }

  if (secretName === "accessToken") {
    if (await window.asos.sdk.identity.customer?.isAuthenticated()) {
      return await window.asos.sdk.identity.getAccessToken();
    }

    window.asos.sdk.identity?.login();
  }
};
